import { Skeleton, Stack, Box } from '@mui/material'
import { styled } from '@mui/material/styles'

interface StackProps {
  size?: string
}

const Container = styled(Stack)<StackProps>`
  box-sizing: border-box;
  padding: ${props =>
    props.size === 'large' ? '8px 15px 8px 0' : '5px 15px 5px 0'};
`

const TextsContainer = styled(Box)`
  flex: 1;
  margin-right: 8px;
`

type SkeletonSize = 'medium' | 'large'

export function UserListItemSkeleton({ size }: { size?: SkeletonSize } = {}) {
  const avatarSize = size === 'large' ? 54 : 46
  return (
    <Container direction="row" alignItems="center" size={size}>
      <Skeleton variant="circular" width={avatarSize} height={avatarSize} />

      <TextsContainer>
        <Skeleton variant="text" width="40%" />
        <Skeleton variant="text" width="60%" height={20} />
      </TextsContainer>
    </Container>
  )
}

UserListItemSkeleton.defaultProps = {
  size: 'medium',
}
